import { useState } from "react";
import Dropdown from "./Dropdown";
import classNames from "classnames";
import Popup from "../../Popup";
import DuplicateProject from "../../DuplicateProject";
import RenameProject from "../../RenameProject";
import DownloadPDF from "../../DownloadPDF";
import { useAppSelector } from "../../../../../hooks/reduxHooks";
import { useSearchParams } from "react-router-dom";

const ProjectDropdown = () => {
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [showRenamePopup, setShowRenamePopup] = useState(false);
  const [showPDFPopup, setShowPDFPopup] = useState(false);
  const designName = useAppSelector((state: any) => state.canvases.designName);
  const [searchParams] = useSearchParams();

  const userId = searchParams.get("userId");
  const guest = searchParams.get("guest");
  return (
    <>
      <div className="relative">
        {userId || designName ? (
          <div
            onClick={() => setDisplayDropdown((prev) => !prev)}
            className="hidden lg:block px-5 py-3 border-r border-solid border-lightgrey font-bold tracking-wide cursor-pointer"
          >
            {designName ? designName : "Please select"}{" "}
            <svg
              className={classNames("inline ml-1", {
                ["rotate-180 -mt-1"]: displayDropdown,
              })}
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L7.5 8C7.5 8 11.5238 3.66667 14 1"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        ) : (
          ""
        )}

        {displayDropdown && (
          <>
            <Dropdown
              hideDropdown={() => setDisplayDropdown(false)}
              showDuplicate={() => setShowDuplicatePopup(false)}
              showRename={() => setShowRenamePopup(true)}
              showPDF={() => setShowPDFPopup(true)}
            />
          </>
        )}
      </div>

      <Popup
        show={showDuplicatePopup}
        setShow={setShowDuplicatePopup}
        title="Duplicate Project"
      >
        <DuplicateProject oldName={"My First Project"} />
      </Popup>

      <Popup
        show={showRenamePopup}
        setShow={setShowRenamePopup}
        title="Rename Design"
      >
        <RenameProject
          oldName={"My First Project"}
          showRenamePopup={setShowRenamePopup}
        />
      </Popup>

      <Popup
        show={showPDFPopup}
        setShow={setShowPDFPopup}
        title="Download The PDF
"
      >
        <DownloadPDF />
      </Popup>
    </>
  );
};
export default ProjectDropdown;
